import React from 'react';
import { FiPercent, FiDollarSign } from 'react-icons/fi';

const FeeEditForm = ({ 
  formData, 
  onInputChange, 
  onSave, 
  onCancel,
  type,
  fields = []
}) => {
  const renderField = (field) => {
    switch (field.type) {
      case 'percentage':
        return (
          <div key={field.name}>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {field.label}
            </label>
            <div className="relative">
              <input
                type="number"
                step="0.01"
                value={formData[field.name] || ''}
                onChange={(e) => onInputChange(field.name, e.target.value)}
                className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#ff660e] focus:border-transparent"
                placeholder={field.placeholder || '0.00'}
              />
              <FiPercent className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            </div>
          </div>
        );
        
      case 'currency':
        return (
          <div key={field.name}>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {field.label}
            </label>
            <div className="relative">
              <input
                type="number"
                step="0.01"
                value={formData[field.name] || ''}
                onChange={(e) => onInputChange(field.name, e.target.value)}
                className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#ff660e] focus:border-transparent"
                placeholder={field.placeholder || '0.00'}
              />
              <FiDollarSign className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            </div>
          </div>
        );
        
      case 'text':
        return (
          <div key={field.name}>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {field.label}
            </label>
            <input
              type="text"
              value={formData[field.name] || ''}
              onChange={(e) => onInputChange(field.name, e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#ff660e] focus:border-transparent"
              placeholder={field.placeholder || ''}
            />
          </div>
        );
        
      case 'textarea':
        return (
          <div key={field.name}>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {field.label}
            </label>
            <textarea
              value={formData[field.name] || ''}
              onChange={(e) => onInputChange(field.name, e.target.value)}
              rows="2"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#ff660e] focus:border-transparent"
              placeholder={field.placeholder || ''}
            />
          </div>
        );
        
      case 'select':
        return (
          <div key={field.name}>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {field.label}
            </label>
            <select
              value={formData[field.name] || ''}
              onChange={(e) => onInputChange(field.name, e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#ff660e] focus:border-transparent"
            >
              {field.options?.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        );
        
      default:
        return null;
    }
  };

  return (
    <div className="space-y-3">
      {fields.map(renderField)}
      
      <div className="flex justify-end space-x-2 pt-2">
        <button
          onClick={onCancel}
          className="px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 text-sm font-medium"
        >
          Cancel
        </button>
        <button
          onClick={onSave}
          className="px-4 py-2 bg-[#ff660e] text-white rounded-lg hover:bg-[#e55c0d] text-sm font-medium"
        >
          Save Changes
        </button>
      </div>
    </div>
  );
};

export default FeeEditForm;